import { UseMutationResult } from '@tanstack/react-query';

export const parseMutationStatus = (
  mutationStatus?: UseMutationResult['status'] | UseMutationResult['status'][]
) => {
  if (!mutationStatus?.length)
    return {
      isPending: false,
      isSuccess: false,
      isError: false,
    };
  if (typeof mutationStatus === 'string') mutationStatus = [mutationStatus];
  if (mutationStatus.some(status => status === 'error'))
    return {
      isPending: false,
      isSuccess: false,
      isError: true,
    };
  // `loading` in tanstack query v4, `pending` in v5
  if (
    mutationStatus.some(status =>
      (['loading', 'pending'] as (string | undefined)[]).includes(status)
    )
  )
    return {
      isPending: true,
      isSuccess: false,
      isError: false,
    };
  // `loading` in tanstack query v4, `pending` in v5
  if (mutationStatus.every(status => status === 'success'))
    return {
      isPending: false,
      isSuccess: true,
      isError: false,
    };
  return {
    isPending: false,
    isSuccess: false,
    isError: false,
  };
};
